import React from 'react';
import { useFormContext } from 'react-hook-form';
import { isAllGroupSelected } from '../MyFilterUtilities';

export const useIsAllSelected = (field: string, allIds: string[]) => {
	const { watch } = useFormContext<{ [field: string]: string[] }>();
	const currentlySelected = watch(field);
	return React.useMemo(() => isAllGroupSelected(currentlySelected, allIds), [currentlySelected, allIds]);
};
